 <template>
 <div>
     <v-progress-linear  style="margin : 0 auto ; height:10px" :indeterminate="isLoading" v-show="isLoading"></v-progress-linear>

     <div>

     </div>
 <div>
  <v-data-table
    :headers="headers"
    :items="emolumentos"

    :sort-desc="true"

    class="elevation-1"
    :search="search"
  >
    <template v-slot:top>
      <v-toolbar flat color="white">

        <v-toolbar-title class="hidden-sm-and-down">
          Listar Pagamento Emolumentos

        </v-toolbar-title>

        <v-divider class="mx-8  hidden-sm-and-down" inset vertical></v-divider>

        <!--  search  -->
        <div v-if="$store.state.hasMessage" :class="$store.state.classMessage">
          {{ $store.state.textMessage }}
        </div>

        <div class="flex-grow-1"></div>

        <v-text-field
          v-model="search"
          append-icon="search"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
        <!-- end  search  -->

        <v-divider class="mx-4 hidden-sm-and-down" inset vertical></v-divider>
 <v-btn  v-if="search"  @click="initialize(search)" text icon color="green">
              <v-icon>cached</v-icon>
            </v-btn>

        <v-spacer></v-spacer>
        <v-dialog v-model="dialog" max-width="500px">
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }} </span>

            </v-card-title>
<div>
    <v-alert v-if="sucess" type="success">
      Pagamento feito com sucesso.
    </v-alert>

    <v-alert v-if="err" type="error">
      O pagamento não foi feito com sucesso.
    </v-alert>
  </div>
            <v-card-text>
              <v-container>
                <v-form ref="form" v-model="formValid" lazy-validation>
                  <v-row>
                    <v-col cols="12" sm="12" md="12">
                      <div
                        v-if="$store.state.hasMessage"
                        :class="$store.state.classMessage"
                      >
                        {{ $store.state.textMessage }}
                      </div>

                    </v-col>
                    <v-col cols="12" sm="12" md="6">

                      <v-text-field
                        v-model="editedItem.instituicao"
                        label="Instituicao"
                         :rules="obrigqtorioRules"
                         disabled
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" sm="12" md="6">
                       <v-text-field

                        v-model="editedItem.preco"
                        :rules="ruleTextRequiredPagamento"
                        label="Preço"
                        disabled
                      ></v-text-field>
                    </v-col>
                     <v-col cols="12" sm="12" md="6">
                       <v-text-field

                        v-model="editedItem.pagamento"
                        :rules="ruleTextRequiredPagamento"
                        label="Pagamento"
                      ></v-text-field>
                    </v-col>
                     <v-col cols="12" sm="12" md="6">
                       <v-text-field

                        v-model="editedItem.consumo"
                        :rules="ruleTextRequiredPagamento"
                        label="Quant. consumida"
                      ></v-text-field>
                    </v-col>
                     <v-col cols="12" sm="12" md="6">
                       <v-text-field v-if="false"
                        v-model="editedItem.quantidade_inicial"
                        :rules="ruleTextRequiredPagamento"
                        label="Quant. inicial"
                        disabled
                      ></v-text-field>
                      </v-col>

                     <v-col cols="12" sm="12" md="6">
                       <v-text-field v-if="false"

                        v-model="editedItem.saldo_transportado"
                        :rules="ruleTextRequiredPagamento"
                        label="Quant. transportada"
                        disabled
                      ></v-text-field>
                      </v-col>
                     <v-col cols="12" sm="12" md="6">
                       <v-text-field v-if="false"

                        v-model="editedItem.quantidade_final"
                        :rules="ruleTextRequiredPagamento"
                        label="Quant. final"
                        disabled
                      ></v-text-field>
                      </v-col>
                  </v-row>
                </v-form>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
              <v-btn
                color="blue darken-1"
                :disabled="
                  !(formValid)
                "
                text
                @click="save"
                >Save</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <template v-slot:item.action="{ item }">
      <v-icon small class="mr-2" @click="editItem(item)">edit</v-icon>
      <v-icon small @click="addPagamento(item)">add</v-icon>
    </template>
    <template v-slot:no-data>
      no data
    </template>
  </v-data-table>
 </div>
 </div>
</template>
<script>
import axios from '../../plugins/axios'
import { mask } from 'vue-the-mask'
const ls = require('local-storage')
export default {
  directives: { mask },
  data: () => ({
    text: '',
    flag_curso: '',
    formValid: true,
    usuarios: [],
    isLoading: false,
    search: '',
    obrigqtorioRules: [value => !!value || 'campo obrigatorio'],
    ruleTextRequiredPagamento: [
      value => !!value || 'campo obrigatório.',
      value => {
        const pattern = /(([.,0-9]))$/
        return !!pattern.test(value) || 'Invalido.'
      }
    ],
    emolumentos: [],
    sucess: false,
    err: false,
    dialog: false,
    headers: [
      {
        text: 'Instituição',
        align: 'left',
        sortable: false,
        value: 'instituicao'
      },
      { text: 'Emolumento', value: 'tipo_emolumento' },
      { text: 'Preço (Unitario)', value: 'preco' },
      { text: 'Pagamento', value: 'pagamento' },
      { text: 'Quant.inicial', value: 'quantidade_inicial' },
      { text: 'Quant. transportada', value: 'saldo_transportado' },
      { text: 'Quant.final', value: 'quantidade_final' },
      { text: 'Quant. consumida', value: 'consumo' },
      { text: 'Data de pagamento', value: 'data_2' },
      { text: 'Actions', value: 'action', sortable: false }
    ],

    editedIndex: -1,
    editedItem: {
      pkPagamentoEmolumento: 0,
      preco: '',
      instituicao: '',
      saldo_transportado: 0,
      quantidade_inicial: 0,
      quantidade_final: 0,
      pagamento: 0,
      consumo: 0,
      resto_transportado: 0,
      restoTotal: 0
    },
    defaultItem: {
      pkPagamentoEmolumento: 0,
      preco: 0,
      instituicao: '',
      saldo_transportado: 0,
      quantidade_inicial: 0,
      quantidade_final: 0,
      pagamento: 0,
      consumo: 0,
      resto_transportado: 0,
      restoTotal: 0
    }
  }),

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'Editar' : 'Editar'
    }

  },

  watch: {
    dialog (val) {
      val || this.close()
    }
  },

  created () {
    this.initializeAllPagamento()
  },

  methods: {

    async initializeAllPagamento (search) {
      this.isLoading = true
      try {
        this.emolumentos = await axios
          .get('/verificarPagamentoAll')
          .then(res => res.data)
        this.isLoading = false
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', {
          msg: this.text,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
    },
    editItem (item) {
      // this.editedItem.pkPagamentoEmolumento = item.pkpagamentoEmolumento
      this.editedItem.quantidade_final = (this.editedItem.pagamento / this.editedItem.preco) + this.editedItem.saldo_transportado
      this.editedIndex = this.emolumentos.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },

    addPagamento (item) {
      this.$router.push('/pagar-emolumentos')
    },

    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    async save () {
      if (this.$refs.form.validate() && this.editedItem.pagamento && this.editedItem.consumo) {
        this.editedItem.quantidade_inicial = this.editedItem.pagamento / this.editedItem.preco
        this.editedItem.quantidade_final = parseInt(this.editedItem.quantidade_inicial) + parseInt(this.editedItem.saldo_transportado)

        try {
          var params = {
            idpessoa: ls.get('idPessoa'),
            pkPagamentoEmolumento: this.editedItem.pkpagamentoEmolumento,
            nome: this.editedItem.instituicao,
            quantidade_inicial: this.editedItem.quantidade_inicial,
            preco: this.editedItem.preco,
            consumo: this.editedItem.consumo,
            instituicao: this.editedItem.instituicao,
            saldo_transportado: this.editedItem.saldo_transportado,
            quantidade_final: this.editedItem.quantidade_final,
            resto: (this.editedItem.pagamento % this.editedItem.preco),
            pagamento: this.editedItem.pagamento

          }
        } catch (error) {

        }

        try {
          let msg = await axios
            .post('/updateEmolumentoPago', params)
            .then(res => res.data)
            // this.text = msg[1].insertId

          this.text = msg
          this.$store.dispatch('textMessage', {
            msg: this.text,
            classMessage: 'msgSucess',
            timeout: 2000
          })

          try {
            if (msg.affectedRows >= 1) {
              this.text = msg.affectedRows + ' gravado(s) com sucesso'
              this.$store.dispatch('textMessage', {
                msg: this.text,
                classMessage: 'msgSucess',
                timeout: 2000
              })
              this.sucess = true
              setTimeout(() => {
                this.sucess = false
              }, 2000)
            }
          } catch (error) {}
          try {
            this.text = msg.message.sqlMessage
            this.$store.dispatch('textMessage', {
              msg: this.text,
              classMessage: 'msgError',
              timeout: 8000
            })
            this.err = true
            setTimeout(() => {
              this.err = false
            }, 2000)
          } catch (error) {}
          try {
            this.text = msg.message.sqlMessage
            this.$store.dispatch('textMessage', {
              msg: this.text,
              classMessage: 'msgError',
              timeout: 8000
            })
          } catch (error) {}
        } catch (error) {
          console.log('eroooo: ' + error)
          this.isLoading = false

          this.text = error.message
          this.$store.dispatch('textMessage', {
            msg: this.text,
            classMessage: 'msgError',
            timeout: 8000
          })
        } finally {
          this.emolumentos[this.editedIndex].pagamento = this.editedItem.pagamento
          this.emolumentos[this.editedIndex].quantidade_inicial = this.editedItem.quantidade_inicial
          this.emolumentos[this.editedIndex].consumo = this.editedItem.consumo
          this.emolumentos[this.editedIndex].resto = (this.editedItem.pagamento % this.editedItem.preco)
          this.emolumentos[this.editedIndex].quantidade_final = this.editedItem.quantidade_final
          this.emolumentos[this.editedIndex].restoTotal = (this.editedItem.pagamento % this.editedItem.preco) + this.editedItem.resto_transportado
          this.close()
        }
      }
    }
  }

}
</script>
